import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from './auth-context.js';
import { AuthRahmen } from './auth-rahmen.js';

export function Guard({ children }: { children: ReactNode }) {
  const { laedt, nutzer } = useAuth();
  const ort = useLocation();

  // Beide Zwischenzustaende stehen in der Marken-Karte wie Anmelden und Einrichten -- vorher
  // erschienen sie als ungestalteter Text auf leerer Flaeche (Story "UI und Einladungsmails
  // durchgaengig gestalten").
  if (laedt) {
    return (
      <AuthRahmen>
        <p role="status">Anmeldung wird geprüft …</p>
      </AuthRahmen>
    );
  }

  if (!nutzer) {
    // Das Ziel wird mitgegeben, damit die Anmeldung dorthin zurueckfuehrt.
    return <Navigate to="/anmelden" replace state={{ ziel: ort.pathname + ort.search }} />;
  }

  if (!nutzer.emailBestaetigt) {
    return (
      <AuthRahmen>
        <div className="eds-alert eds-alert--warning" role="alert">
          <div>
            <p className="eds-alert__title">Ihre E-Mail-Adresse ist noch nicht bestätigt.</p>
            <p>
              Bitte öffnen Sie den Link aus der Einladungsmail. Danach können Sie diese Seite
              benutzen.
            </p>
          </div>
        </div>
      </AuthRahmen>
    );
  }

  // Geprueft wird der Anspruch der SITZUNG, nicht ob das Konto einen Faktor hat: Genau
  // diesen Anspruch verlangen die Firestore-Rules und das Backend.
  if (!nutzer.mitZweitemFaktor) {
    return <Navigate to="/zweiter-faktor/einrichten" replace />;
  }

  return <>{children}</>;
}
